import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';

const TagItemIO = t.interface({
    label: t.string,
    values: t.array(t.interface({
        id: t.string,
        isDefault: t.boolean,
        label: t.string,
    })),
});

export type TagItemType = t.TypeOf<typeof TagItemIO>;

const isTagItem = createGuard(TagItemIO);

const ResponseIO = t.interface({
    definitions: t.record(t.string, t.unknown)
});

const isResponse = createGuard(ResponseIO);

const decode = (status: number, data: ResponseType): Map<string, TagItemType> => {
    if (status === 200 && data.type === 'json') {
        if (isResponse(data.json)) {
            const result: Map<string, TagItemType> = new Map();

            for (const [name, definition] of Object.entries(data.json.definitions)) {
                if (isTagItem(definition)) {
                    result.set(name, definition);
                } else {
                    console.error('Decoding problem with TagItemIO', definition);
                }
            }

            return result;
        } else {
            throw new Error('Decoding problem ResponseIO in tags.getAll');
        }
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export const getAllTags = {
    browser: {
        params: (): ParamsFetchType<void> => {
            return {
                type: MethodType.GET,
                url: '/api-web/tags/get-all',
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.GET,
        urlBrowser: '/api-web/tags/get-all',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<void>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }

        return {
            url: `${params.API_URL}/operator-tags/${params.API_UNIVERSE}`,
            passToBackend: true,
            method: MethodType.GET,
        };
    }
};
